import * as yup from "yup";

export const StatutoryHolidaySetupValidationSchema = yup.object().shape({
    holidayLabel: yup
  .string()
  .required("Holiday Name is required")
  .min(1, "Minimum length 1 characters")
  .max(50, "Maximum length 50 characters")
});
